import { batch, computed, signal } from "@preact/signals-react"

// Table data
export const tableData = signal([])
export const summaryData = signal(null)
export const isLoadingTable = signal(false)

// Filters
export const filterDateFrom = signal(null)
export const filterDateTo = signal(null)
export const filterQuick = signal('thisMonth') // 'today', 'thisWeek', 'thisMonth', 'last30Days', 'none'
export const excludePropagated = signal(true) // Exclude propagated by default

// User Detail Drawer
export const userDetailOpen = signal(false)
export const selectedUser = signal(null)
export const userActivityData = signal(null)
export const userStatsData = signal(null)
export const isLoadingUserDetail = signal(false)

// Computed: filters as object for API call
export const filtersValue = computed(() => ({
    date_from: filterDateFrom.value || undefined,
    date_to: filterDateTo.value || undefined,
    exclude_propagated: excludePropagated.value
}))

// Clear all signals
export const clearUserStatsSignals = () => batch(() => {
    tableData.value = []
    summaryData.value = null
    isLoadingTable.value = false
    filterDateFrom.value = null
    filterDateTo.value = null
    filterQuick.value = 'thisMonth'
    excludePropagated.value = true
    userDetailOpen.value = false
    selectedUser.value = null
    userActivityData.value = null
    userStatsData.value = null
    isLoadingUserDetail.value = false
})

// Clear only filters (keep data)
export const clearFilters = () => batch(() => {
    filterDateFrom.value = null
    filterDateTo.value = null
    filterQuick.value = 'none'
    excludePropagated.value = true
})

// Apply quick filter dates
export const applyQuickFilter = (quickFilter) => {
    const now = new Date()
    const today = now.toISOString().split('T')[0]

    batch(() => {
        filterQuick.value = quickFilter

        switch (quickFilter) {
            case 'today': {
                filterDateFrom.value = today
                filterDateTo.value = today
                break
            }
            case 'thisWeek': {
                const weekAgo = new Date(now - 7 * 24 * 60 * 60 * 1000)
                filterDateFrom.value = weekAgo.toISOString().split('T')[0]
                filterDateTo.value = today
                break
            }
            case 'thisMonth': {
                // First day of current month
                const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
                filterDateFrom.value = firstDay.toISOString().split('T')[0]
                filterDateTo.value = today
                break
            }
            case 'last30Days': {
                const thirtyDaysAgo = new Date(now - 30 * 24 * 60 * 60 * 1000)
                filterDateFrom.value = thirtyDaysAgo.toISOString().split('T')[0]
                filterDateTo.value = today
                break
            }
            case 'none':
            default:
                // Custom - keep current values or null
                break
        }
    })
}
